import { useMutation } from '@apollo/client';
import { UPDATE_REPORT } from '../../apollo/reports.ts';
import {
  QuestionReportErrorType,
  QuestionReportFilterInput,
  QuestionReportStatus,
} from '../../apollo/__generated__/graphql.ts';
import { toast } from 'react-toastify';
import { useCallback, useState } from 'react';

export const useUpdateReport = () => {
  const [update] = useMutation(UPDATE_REPORT);

  const onChangeStatus = (id: number, status: QuestionReportStatus) => {
    const promise = update({
      variables: { input: { id, status } },
    });
    toast.promise(promise, {
      pending: 'Changing status...',
    });
  };

  return { onChangeStatus };
};

export const useReportsFilter = () => {
  const [filter, setFilter] = useState<QuestionReportFilterInput>({
    errorType: undefined,
    status: undefined,
    questionId: undefined,
    questionSectionId: undefined,
  });
  const onChangeFilter = useCallback((value?: string, type?: string) => {
    setFilter((prev) => {
      const input = value || undefined;
      const next: QuestionReportFilterInput = {
        errorType:
          type === 'errorType'
            ? (input as QuestionReportErrorType | undefined)
            : undefined,
        status:
          type === 'status'
            ? (input as QuestionReportStatus | undefined)
            : undefined,
        questionId: type === 'questionId' && value ? Number(value) : undefined,
        questionSectionId:
          type === 'questionSectionId' && input ? Number(input) : undefined,
      };

      if (
        prev.errorType === next.errorType &&
        prev.status === next.status &&
        prev.questionId === next.questionId &&
        prev.questionSectionId === next.questionSectionId
      ) {
        return prev;
      }

      return next;
    });
  }, []);

  return { filter, onChangeFilter };
};
